<script lang="ts" setup>
import { RouterView, useRoute } from "vue-router";

const route = useRoute();
</script>

<template>
  <div full overflow-hidden>
    <RouterView v-slot="{ Component }">
      <transition name="slide-fade-left" mode="out-in">
        <keep-alive>
          <component :is="Component" :key="route.path" />
        </keep-alive>
      </transition>
    </RouterView>
  </div>
</template>

<style lang="scss">
$easeInOut2: all 0.2s ease-in-out;
$easeInOut3: all 0.3s ease-in-out;

.slide-fade {
  &-enter-active,
  &-leave-active {
    transition: $easeInOut3;
  }

  &-enter-active {
    opacity: 0;
    visibility: hidden;
  }

  &-enter-to {
    opacity: 1;
    visibility: visible;
  }

  &-leave-to {
    opacity: 0;
    visibility: hidden;
  }

  // Left
  &-left {
    &-enter-active,
    &-leave-active {
      transition: $easeInOut3;
    }

    &-enter-active {
      transform: translateX(-10px);
      opacity: 0;
      visibility: hidden;
    }

    &-enter-to {
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
    }

    &-leave-to {
      transform: translateX(10px);
      opacity: 0;
      visibility: hidden;
    }
  }

  // Right
  &-right {
    &-enter-active,
    &-leave-active {
      transition: $easeInOut3;
    }

    &-enter-active {
      transform: translateX(10px);
      opacity: 0;
      visibility: hidden;
    }

    &-enter-to {
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
    }

    &-leave-to {
      transform: translateX(-10px);
      opacity: 0;
      visibility: hidden;
    }
  }

  // Top
  &-top {
    &-enter-active,
    &-leave-active {
      transition: $easeInOut3;
    }

    &-enter-active {
      transform: translateY(-10px);
      opacity: 0;
      visibility: hidden;
    }

    &-enter-to {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }

    &-leave-to {
      transform: translateY(10px);
      opacity: 0;
      visibility: hidden;
    }
  }
}

.fade-in {
  &-enter-active,
  &-leave-active {
    transition: $easeInOut2;
  }

  &-enter-active {
    transform: scale(0.8);
    opacity: 0;
    visibility: hidden;
  }

  &-enter-to {
    transform: scale(1);
    opacity: 1;
    visibility: visible;
  }

  &-leave-to {
    transform: scale(0.8);
    opacity: 0;
    visibility: hidden;
  }
}

.el-empty__description {
  p {
    color: #666666 !important;
  }
}
</style>
